import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Ingredient = ApplicationRecord.extend({
  attrs: {
    categorisation: belongsTo({ type: 'recipes-ingredient_categorisation' }),
    categorisation_id: attr({ type: Number }),
    components: hasMany({ type: 'recipes-components' }),
    allergen_presences: hasMany({ type: 'recipes-allergen_presences' }),
    id: attr(),
    code: attr(),
    name: attr(),
    ingredient_type: attr(),
    description: attr(),
    food_group: attr(),
    calories: attr({ type: Number }),
    protein: attr({ type: Number }),
    fat: attr({ type: Number }),
    carbohydrates: attr({ type: Number }),
    sugars: attr({ type: Number }),
    salt: attr({ type: Number }),
    fibre: attr({ type: Number }),
    saturated_fat: attr({ type: Number }),
    expected_quality_jan: attr(),
    expected_quality_feb: attr(),
    expected_quality_mar: attr(),
    expected_quality_apr: attr(),
    expected_quality_may: attr(),
    expected_quality_jun: attr(),
    expected_quality_jul: attr(),
    expected_quality_aug: attr(),
    expected_quality_sep: attr(),
    expected_quality_oct: attr(),
    expected_quality_nov: attr(),
    expected_quality_dec: attr(),
    swk_speed_veg: attr({ type: Boolean })
  },
  static: {
    endpoint: '/ingredients',
    jsonapiType: 'recipes-ingredients',
  },
  methods: {
    allergens() {
      if (this.allergen_presences.length < 14) {
        throw new Error('Ingredient needs to include 14 allergen presences');
      } else if (
        this.allergen_presences.some(
          (presence) => presence.contains === undefined,
        )
      ) {
        throw new Error(
          "Ingredient's allergen presences needs to include contains",
        );
      }
      const filteredAllergenPresences = this.allergen_presences.filter(
        (presence) => presence.contains,
      );
      const allergens = filteredAllergenPresences.map(
        (allergenItem) => allergenItem.allergen,
      );
      return allergens;
    },
  },
});

export default Ingredient;
